import React, { useState } from "react";
import AboutTab from "./tabs/AboutTab";
import StatsTab from "./tabs/StatsTab";

const TABS = [
  { label: "About", component: AboutTab },
  { label: "Stats / Experience", component: StatsTab },
];

const UmpireTabs = ({ umpire }) => {
  const [activeTab, setActiveTab] = useState(0);
  const ActiveComponent = TABS[activeTab].component;
  return (
    <div>
      <div className="flex gap-4 border-b pb-2 mb-2">
        {TABS.map((tab, idx) => (
          <button
            key={tab.label}
            className={`font-semibold px-2 pb-1 border-b-2 transition ${
              activeTab === idx
                ? "border-green-600 text-green-700"
                : "border-transparent text-gray-500 hover:text-green-700"
            }`}
            onClick={() => setActiveTab(idx)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="p-6 bg-white rounded shadow">
        <ActiveComponent umpire={umpire} />
      </div>
    </div>
  );
};

export default UmpireTabs; 